import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";
import range from "lodash/range";
const languageRE = /^([a-z]{2,3})([-_]|$)/;
const regionRE = /[-_]([A-Z]{2})([-_]|$)/;
const getLanguageSubtag = locale => {
  const caseInsensitiveLocale = locale.toLowerCase();
  const r = languageRE.exec(caseInsensitiveLocale);
  return r ? r[1] : undefined;
};
function getRegionSubtag(locale) {
  const caseInsensitiveLocale = locale.toUpperCase();
  const r = regionRE.exec(caseInsensitiveLocale);
  return r ? r[1] : undefined;
}
export const getCountryCodeFromLocale = locale => {
  return getRegionSubtag(locale);
};
export const getLanguageFromLocale = locale => {
  return getLanguageSubtag(locale);
};
export const getBrowserLocale = () => {
  return window.navigator.userLanguage || window.navigator.language;
};
export const normalizeToUnderscoreLocale = locale => {
  return locale.replace('-', '_');
};
export const isIntlShape = content => content && content.id !== undefined && content.defaultMessage !== undefined;
export const getFormattedMonthsForLocale = locale => {
  var _context;
  return _mapInstanceProperty(_context = range(12)).call(_context, month => locale.localize.month(month));
};